import { withSearch } from './lib/helper/LocationHelper';
import { launchPanelApp } from './lib/PanelApp';

// Page specific code :
import ServerAddPage from './pages/server-add/ServerAdd';

const ServerAddPageWithSearch = withSearch(ServerAddPage);

launchPanelApp(ServerAddPageWithSearch, {});
